import styled from 'styled-components';
import { gridSizes, zIndexses } from 'utils/style';

import FiltersBox from 'components/orders/Filters/Filters/Dates/FiltersBox/container';

export default styled(FiltersBox)`
  border-radius: ${gridSizes('S')};
  box-shadow: 1px 1px 1px;
  padding: ${gridSizes('M')};
  position: absolute;
  margin: 0;
  padding: 4px 0;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.27);
  background-color: #fff;
  border-radius: 4px;
  border: solid 1px var(--grey300);
  width: 300px;
  z-index: ${zIndexses.datesFilterBox};
  transform: translateX(-10%) translateY(45px);
  padding: ${gridSizes('L')};
  min-width: 380px;

  .fields-container {
    display: flex;
    flex-direction: row;

    .icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: ${zIndexses.datesFilterBoxIcon};
    }

    .field-from {
      padding-right: ${gridSizes('S')};
      .icon {
        right: 20px;
      }
    }

    .field-to {
      padding-left: ${gridSizes('S')};
      .icon {
        right: 12px;
      }
    }
  }

  .buttons-container {
    margin-top: ${gridSizes('M')};
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .remove-btn {
      button {
        padding: 0;
      }
    }
  }
`;
